import { Video } from './../../models/video.model';
import { UtilService } from './../../services/util.service';
import { Router } from '@angular/router';
import { AuthBaseService } from './../../services/auth/auth-base.service';
import { Token } from './../../models/token.model';
import { LoginModalService } from './../../services/auth/login-modal.service';
import { environment } from './../../../environments/environment';
import { Home } from './../../models/home.model';
import { Response } from './../../models/response.model';
import { BaseService } from './../../services/base/base.service';
import { Component, HostListener, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import Swiper from 'swiper';
import { BannerHome } from 'src/app/models/banner-home.model';
import { BannerHomeService } from 'src/app/services/banner-home.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  storageUrl = environment.BASE_STORAGE_URL;

  data: Home = new Home();
  bannerHome: BannerHome[] = [];

  currentLoggedUser: Token = new Token();

  dataSubscription: Subscription;
  currentLoggedUserSubscription: Subscription;

  videoList: Video[] = [];

  @HostListener('window:scroll', ['$event'])
  doSomething(event) {
    if (window.pageYOffset >= 200) {
      document
        .getElementById('animateSeccion')
        .classList.add('presentation-animate');
    }
  }

  public config: SwiperConfigInterface = {
    direction: 'horizontal',
    keyboard: true,
    mousewheel: false,
    observer: true,
    // width: 'auto',
    watchOverflow: true,
    allowTouchMove: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    // spaceBetween: 40,
    //navigation: true,
    scrollbar: false,
    autoplay: {
      delay: 10000,
      disableOnInteraction: false,
    },
    breakpoints: {
      1: {
        slidesPerView: 1,
      } /*,
      960: {
        slidesPerView: 4,
      }*/,
    },
  };

  constructor(
    private baseService: BaseService,
    private authBaseService: AuthBaseService,
    private loginModalService: LoginModalService,
    private bannerHomeService: BannerHomeService,
    private router: Router,
    private utilService: UtilService
  ) {}

  ngOnInit(): void {
    this.getBanner();
    this.getLoggedUser();
    this.getData();

    this.getVideos();
  }

  getBanner(): void {
    const ativo: boolean = true;
    this.bannerHomeService
      .getAllBannerNew(1)
      .subscribe((res: Response<BannerHome[]>) => {
        if (res) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].pathImagem = this.storageUrl + res.data[i].pathImagem;
          }

          this.bannerHome = res.data;
        }
      });
  }

  getData(): void {
    this.dataSubscription = this.baseService
      .getAllNoHeader('home')
      .subscribe((res: Response<Home>) => {
        if (res.retorno) {
          this.data = res.data;
          this.data.eventos = this.data.eventos.splice(0, 4);
        }
      });
  }

  getVideos(): void {
    const videoSub = this.baseService
      .getAllNoHeader('video-home/buscarVideosHome')
      .subscribe((res: Response<Video[]>) => {
        this.videoList = res.data;
        // for (let i = 0; i < res.data.length; i++) {
        //   let vid = res.data[i].video as string;

        //   res.data[i].video = this.utilService.sanitizeUrl(vid.split('&')[0]);
        //   this.videoList.push(res.data[i]);
        // }
      });
    // this.dataSubscription.add(videoSub);
  }

  getLoggedUser(): void {
    this.currentLoggedUserSubscription = this.authBaseService
      .watchUsuarioLogado()
      .subscribe((res: Token) => {
        this.currentLoggedUser = res;
      });
  }

  openSignupModal(): void {
    this.loginModalService.openModalSignUp();
  }

  redirectProduct(titulo: string): void {
    if (titulo.toUpperCase().includes('PRES')) {
      this.router.navigate(['products/presencial']);
    } else {
      this.router.navigate(['products/digital']);
    }
  }

  abrirLink(link: string): void {
    if (!link.includes('http')) {
      link = 'https://' + link;
    }
    window.open(link, '_blank');
  }

  ngOnDestroy(): void {
    this.dataSubscription.unsubscribe();
    this.currentLoggedUserSubscription.unsubscribe();
  }
}
